import React from 'react';

export default function PerformanceRecordsPage() {
  return (
    <div>
      <h2>Performance Records</h2>
      <p>This is where you’ll see all past performance reports for your vessel.</p>
    </div>
  );
}
